import * as React from "react";
import { observer } from "mobx-react-lite";
import { Button, Input, Space } from "antd";
import { SettingOutlined } from "@ant-design/icons";
import { onError } from "src/common/onError";
import { Mc2EntityStore } from "../Mc2EntityStore";
import { Mc2EntityBaseSizeModal } from "./Mc2EntityBaseSizeModal";

interface PropsMc2EntityBaseSize {
  store: Mc2EntityStore;
}

export const Mc2EntityBaseSize: React.FC<PropsMc2EntityBaseSize> = observer(
  ({ store }) => (
    <Space.Compact style={{ width: "100%" }}>
      <Input disabled readOnly value={store.mcEntity.baseSize ?? ""} />
      {!store.readOnly && (
        <Button
          icon={<SettingOutlined />}
          disabled={store.buzy}
          onClick={() => {
            store.startBaseSizeChange().catch(onError);
          }}
        />
      )}
      <Mc2EntityBaseSizeModal
        open={store.mode === "baseSize"}
        close={() => store.setMode(null)}
        options={store.baseSizeOptions}
        currentBaseSize={store.mcEntity.baseSize ?? ""}
        onChange={(baseSize) => store.changeBaseSize(baseSize)}
        loading={store.taskType === "baseSize"}
      />
    </Space.Compact>
  ),
);
